import { getMeta } from "./parent-utils";
const { VERSION } = require('./version.js');
console.log("parentPage", VERSION);

const MERLIN_HOST = process.env.MERLIN_HOST;

function getScripts() {
  const scripts = document.getElementsByTagName("script");
  let scripts_var = [];
  for (var i = 0; i < scripts.length; i++) {
    if (scripts[i].src) {
      scripts_var.push(scripts[i].src);
    }
  }

  return scripts_var;
}
function isMyScriptLoaded(url) {
  var scripts = document.getElementsByTagName("script");
  for (var i = scripts.length; i--; ) {
    if (scripts[i].src == url) return true;
  }
  return false;
}

function getQueryParamsSettings() {
  const query = window.location.search.substring(1);
  const params = getQueryParams(query);

  const new_params = {};
  for (const key in params) {
    const new_key = key.charAt(0).toLowerCase() + key.slice(1);
    // Map frequency to recurring_option and ensure uppercase
    if (new_key === 'frequency') {
      new_params['recurring_option'] = params[key].toUpperCase();
    // } else if (new_key === 'merlinMemo') {
    //   // Handle MerlinMemo parameter and keep its name
    //   new_params['merlinMemo'] = params[key];
    } else {
      new_params[new_key] = params[key];
    }
  }

  return new_params;
}

function appendScript(script_url) {
  if (isMyScriptLoaded(script_url)) {
    // all good
  } else {
    let script_tag = document.createElement("script");
    script_tag.src = script_url;
    document.body.appendChild(script_tag);
  }
}

function getQueryParams(qs) {
  if (qs) {
    qs = qs.split("+").join(" ");

    var params = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;

    while ((tokens = re.exec(qs))) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  }

  return {};
}

function addBeforeScripts() {
  appendScript("https://js.stripe.com/v3/");
  appendScript(
    `${MERLIN_HOST}/assets/form-parent-page-post-robot-script.js?vsn=${VERSION}`
  );
  appendScript(`${MERLIN_HOST}/assets/iframeResizer.min.js`);
}

function addAfterScripts() {
  appendScript("https://js.stripe.com/v2/");
}

function getWidgetKey() {
  const srcs = getScripts();
  const install_script = srcs.find((s) => s.match("form-install-script"));
  const install_query = install_script.split("?")[1];

  const query_parameters = getQueryParams(install_query);

  return query_parameters.key;
}

function initMerlinForm(settings, form_div) {
  addBeforeScripts()
  const windowSettings = window.simpleDonationMerlinSettings;

  const enrichedSettings = Object.assign({}, settings, windowSettings);

  const widget_key = getWidgetKey();
  //
  // Entity and EntityType used for Fundraising Opportunity in Rock
  //
  const rock_entity_type_id = enrichedSettings.rockEntityTypeId || enrichedSettings.merlinFormEntityTypeId;
  const rock_entity_id = enrichedSettings.rockEntityId || enrichedSettings.merlinFormEntityId;
  const rock_financial_account_id = enrichedSettings.rockFinancialAccountId;

  const domain = window.location.protocol + "//" + window.location.host;
  const url = window.location.host + window.location.pathname;

  const person_uuid = enrichedSettings.personId;

  const rock_businesses = enrichedSettings.rockBusinesses
    ? enrichedSettings.rockBusinesses.map(business => ({
        ...business,
        Email: business.Email || '',
        Id: String(business.Id)
      }))
    : null;

  const primary_color = enrichedSettings.merlinPrimaryColor?.replace(/^#/, '') || enrichedSettings.merlinPrimaryColor;

  const background_color = enrichedSettings.merlinBackgroundColor?.replace(/^#/, '') || enrichedSettings.merlinBackgroundColor;

  const test_mode = enrichedSettings.testMode;

  const merlin_mode = enrichedSettings.merlinMode;

  const default_business = enrichedSettings.merlinDefaultBusiness;

  const email = enrichedSettings.email;

  const first_name = enrichedSettings.firstName;

  const collect_address_for_this_user = !first_name;

  const last_name = enrichedSettings.lastName;

  const initial_fund_id = enrichedSettings.fundId;

  // Cast amount to integer if present
  const initial_amount_cents = enrichedSettings.amountCents ? parseInt(enrichedSettings.amountCents, 10) : null;

  const recurring_option = enrichedSettings.recurring_option;

  const allowed_to_logout = person_uuid == "undefined" || person_uuid == "null" || person_uuid == "notLoggedIntoRock" || person_uuid == "rockLoggedInNoSdPerson" || person_uuid == null || person_uuid == ""

  const person_or_business = default_business == "true" ? "business" : "person"

  const settings_with_nulls = {
    allowed_to_logout: allowed_to_logout,
    background_color: background_color,
    collect_address_for_this_user: collect_address_for_this_user,
    domain: domain,
    email: email,
    first_name: first_name,
    recurring_option: recurring_option,
    initial_amount_cents: initial_amount_cents,
    initial_fund_id: initial_fund_id,
    last_name: last_name,
    merlin_mode: merlin_mode,
    person_id: person_uuid,
    person_or_business: person_or_business,
    rock_businesses: rock_businesses,
    rock_entity_id: rock_entity_id,
    rock_entity_type_id: rock_entity_type_id,
    rock_financial_account_id: rock_financial_account_id,
    test_mode: test_mode,
    url: url,
    widget_key: widget_key,
    memo: enrichedSettings.merlinMemo,
  };

  // remove the null or undefined values
  const final_settings = Object.keys(settings_with_nulls).reduce((query, key) => {
    if (settings_with_nulls[key] !== null && settings_with_nulls[key] !== undefined) {
      query[key] = settings_with_nulls[key];
    }
    return query;
  }, {});

  // Store final_settings for later use with postRobot
  window.merlinFormSettings = final_settings;

  // Create and append the iframe after settings are set
  let iframe_tag = document.createElement("iframe");
  iframe_tag.id = "merlin-form-iframe";
  iframe_tag.allowPaymentRequest = true;
  iframe_tag.src = `${MERLIN_HOST}/form?widget_key=${widget_key}&person_id=${person_uuid}&primary_color=${primary_color}`;
  iframe_tag.setAttribute(
    "style",
    "margin: 0 !important; padding: 0 !important; border: 0 !important; width: 100% !important; height: 600px;"
  );
  form_div.appendChild(iframe_tag);

  const iframe_resize_script = document.createElement("script");
    iframe_resize_script.innerHTML = `iFrameResize({log: false, checkOrigin: false, heightCalculationMethod: 'max'}, '#merlin-form-iframe');`;
    window.setTimeout(() => {
      document.body.appendChild(iframe_resize_script);
    }, 500);

  addAfterScripts();

  //
  // removed 2025-04-28, thecrossingchurch.com doesn't like how it runs the user past all their
  // above the fold content, can I can't think of a good reason to snap to the form on load. If you have
  // text content above the form we shouldn't skip that, if you don't, then what are we scolling to anyway?
  // feel free to delete this comment and code after 2025-12-31
  //
  // setTimeout(() => {
  //   window.scrollTo(0, 0);
  // }, 800);
}

var form_div = document.getElementById("merlin-form");

if (form_div) {
  const dataset = form_div.dataset;
  const parent_page_query_param_settings = getQueryParamsSettings();
  const data = Object.assign({}, dataset, parent_page_query_param_settings);
  initMerlinForm(data, form_div);
}
